import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "../../assets/styles/local/AddPurchasingOrder.css";
import "../../assets/styles/local/ConfirmPurchasingOrder.css";
import Header from "../../layouts/Header";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import { formattedCurrency } from "../../utils/helpers/calculateTime";
// import { FetchProductBysupplierid } from "../../redux/actions/action";
import { FetchPurchasingOrder } from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import {
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import ColorTag from "./ColorTag";
import { Image } from "react-bootstrap";
import plusBorderWhite from "../../assets/icons/Plus-border-white.svg";
import Package from "../../assets/icons/package.svg";
import "../../assets/styles/local/ViewPurchasingOrder.css";
import CurrencyInput from "react-currency-input";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import AddPurchaseOrderDocument from "./AddPurchaseOrderDocument";

const ViewPurchasingOrder = () => {
  const dispatch = useDispatch();
  const { orderCode } = useParams();
  const history = useHistory();
  const location = useLocation();
  // const { supplierid, suppliername, projectname } = location.state;

  const [suppliername, setSuppliername] = useState("");
  const [projectname, setProjectname] = useState("");
  const [fetchProductsData, setFetchProductsData] = useState([]);
  const [totalExclusiveBtw, setTotalExclusiveBtw] = useState("");
  const fetchProductBySupplierIdList = useSelector(
    (state) => state.user.fetchProductBySupplierId,
  );
  const fetchPurchasingOrder = useSelector(
    (state) => state.user.fetchPurchasingOrder,
  );

  // useEffect(() => {
  //   if (supplierid) {
  //     dispatch(FetchProductBysupplierid(supplierid));
  //   }
  // }, [dispatch, supplierid]);

  const orderid = window.localStorage.getItem("orderid");

  useEffect(() => {
    if (orderid) {
      dispatch(FetchPurchasingOrder(orderid));
    }
  }, [dispatch, orderid]);

  useEffect(() => {
    if (fetchPurchasingOrder?.status === true) {
      // setApimessage(fetchProject?.data?.message)
      setSuppliername(fetchPurchasingOrder?.data[0]?.suppliername);
      setProjectname(fetchPurchasingOrder?.data[0]?.projectname);
      setFetchProductsData(fetchPurchasingOrder?.data[0]?.orderproduct);
      setTotalExclusiveBtw(fetchPurchasingOrder?.data[0]?.totalExclusiveBtw);
    } else {
      // setApimessage(fetchPurchasingOrder?.message);
    }

    // setTimeout(() => {
    //   setShowLoader(false);
    // }, 1000);
  }, [fetchPurchasingOrder]);

  // useEffect(() => {
  //   if (
  //     fetchProductBySupplierIdList != null &&
  //     fetchProductBySupplierIdList?.status
  //   ) {
  //     setFetchProductsData(fetchProductBySupplierIdList?.data);
  //   }
  // }, [ fetchProductBySupplierIdList ]);
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  useEffect(() => {
    fetchScreenTranslations("Add Purchasing Order").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  return (
    <div className="container-fluid main-wrapper mb-4">
      <div className="containerBox">
        <div className="stock-heading-box">
          <div
            className="stock-heading cursor-pointer"
            onClick={() => {
              history.push("/stock");
            }}
          >
            {t("Stock")}
          </div>
          <div className="confirm-box-title">
            <div className="opacity-1">{t("Purchasing Order")}</div>
            <div className="stock-order-id">ID {orderCode}</div>
          </div>
        </div>
        <Header />
      </div>
      <div className="d-flex align-items-center justify-content-end">
        <button
          type="button"
          className="btn addParchCancel me-4"
          onClick={() => {
            history.goBack();
          }}
        >
          {t("Cancel")}
        </button>
        <button
          type="button"
          className="btn addParchAdd add-btn-disable"
          disabled
        >
          {t("Add")}
        </button>
      </div>
      <div className="PurchScrollWidth">
        <div className="supplierDiv ms-4 me-5 mt-5 ps- py-3">
          <table className="table table-borderless">
            <thead>
              <tr className="">
                <th className="col purchSupplier ps- d-none">
                  {t("Supplier")}
                </th>
                <th className="col-4 pt-1 ps-4">
                  <div className="asc-input-container" id="ascInput">
                    <label className="asc-label-top ClientNameText">
                      {t("Supplier")}
                    </label>
                    <p
                      className="asc_NormalInput mb-0 p-3"
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#323232",
                        background: "white",
                      }}
                    >
                      {suppliername}
                    </p>
                  </div>
                </th>
                <th className=""></th>
                <th className="col purshProject ps- d-none">{t("Project")}</th>
                <th className="col-4 pt-1 ps-2">
                  <div className="asc-input-container" id="ascInput">
                    <label className="asc-label-top ClientNameText">
                      {t("Project")}
                    </label>
                    <p
                      className="asc_NormalInput mb-0 p-3"
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#323232",
                        background: "white",
                      }}
                    >
                      {projectname}
                    </p>
                  </div>
                </th>

                <th className="col"></th>

                <th className="col ps-2" style={{ paddingTop: "32px" }}>
                  <AddPurchaseOrderDocument
                    // poOrderCode={poOrderCode}
                    orderid={orderid}
                    isDisabled={true}
                  />
                </th>

                <th className="col"></th>
              </tr>
            </thead>
          </table>
        </div>

        <div className="supplierDiv px-4 mt-3 ms-4 me-5 py-3">
          <table className="table table-borderless m-0">
            <thead>
              <tr
                className="purchSupplierCode ps-"
                style={{
                  color: "#323232",
                  fontWeight: 600,
                  opacity: "50%",
                }}
              >
                <th className="col pb-4 ps-"></th>
                <th className="col-4 pb-4 ps-3">{t("Product Description")}</th>
                <th className="col pb-4 ps-" style={{ width: "60%" }}>
                  {t("Supplier Code")}
                </th>
                <th className="col pb-4 ps-">{t("Unit Price\t")}</th>
                <th className="col pb-4 ">{t("Qty")}</th>
                <th className="col pb-4 ">{t("Unit")}</th>
                <th className="col pb-4 text-center">
                  {t("Lead Time")}
                  <br />
                  <span className="">({t("Days")})</span>
                </th>
                <th className="col-2 pb-4 purchTotal ps-4">{t("Total")}</th>
              </tr>
            </thead>

            {fetchProductsData.map((item, index) => {
              return (
                <tbody className="horizontalBorderTop" key={index}>
                  <tr className="text-center">
                    <td className="title-hover align-middle">
                      <div className="items-desc-column6">
                        <div className="desc-image-wrp6 desc-image6 ">
                          {item.coverimage ? (
                            <>
                              <div
                                className={`product-list-image-default6 ${
                                  item.image.length === 0 ? "hover-hide6" : ""
                                }`}
                              >
                                <img
                                  src={item.coverimage}
                                  alt=""
                                  className="cover-image6"
                                />
                                {item.image && item.image.length > 0 && (
                                  <div className="image-row6">
                                    {item.image
                                      .slice(0, 3)
                                      .map((val, index) => (
                                        <img
                                          key={index}
                                          src={val}
                                          alt={`Images ${index + 1}`}
                                        />
                                      ))}
                                  </div>
                                )}
                              </div>
                              {item.image && item.image.length > 0 && (
                                <span className="desc-image-plus6">
                                  <Image
                                    height={10}
                                    width={10}
                                    src={plusBorderWhite}
                                  />
                                </span>
                              )}
                            </>
                          ) : (
                            <div className="product-list-default6">
                              <img
                                src={Package}
                                alt=""
                                className="default-img6"
                              />
                              <div className="product-image-title">
                                {t("Picture")}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </td>

                    <td
                      className="documntName text-start ps-3 py-4"
                      style={{
                        fontSize: "16px",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {item.productname}
                    </td>

                    <td className="col-4 text-start ps-0 py-">
                      <img
                        src={item?.barCode}
                        alt=""
                        style={{ width: "100%", height: "80px" }}
                      />
                      <br />
                      {/* {item.suppliercode} */}
                    </td>

                    <td className="documntName ps- py-4 fw-bold">
                      {/* {europeanFormatWithSymbol(
                        item?.productcost.replace(",", ""),
                      )} */}

                      <CurrencyInput
                        className="documntName text-start"
                        placeholder="0"
                        disabled
                        value={item.productcost}
                        decimalSeparator=","
                        thousandSeparator="."
                        precision="2"
                        allowEmpty={true}
                        prefix="€ "
                        style={{
                          // border: fieldErrors?.[index]?.costprice
                          //   ? "1px solid red"
                          //   : "",
                          border: "none",
                        }}
                      />
                    </td>

                    <td className="documntName py-4 d-none">
                      {/* <ColorTag tagList={item.productcolor}></ColorTag> */}
                      {/* <ColorTag tagList={[ item.productcolor ]}></ColorTag> */}
                      <div
                        className="asc_color_code"
                        style={{
                          backgroundColor: `${item.productcolor}`,
                        }}
                      ></div>
                    </td>

                    <td className="documntName py-4">
                      {/* {item?.orderproductqty ? item?.orderproductqty : ""} */}
                      {item?.orderproductqty
                        ? parseFloat(item?.orderproductqty)
                        : ""}

                      {/* {item?.orderproductqty
                        ? Number(item?.orderproductqty).toLocaleString("nl-NL")
                        : ""} */}
                    </td>

                    <td className="documntName py-4">{item?.unit}</td>

                    <td className="documntName py-4">{item?.leadtime}</td>

                    <td className="py-4 ps-3">
                      {europeanFormatWithSymbol(
                        Number(
                          item.productcost
                            ?.replace(/\./g, "")
                            .replace(",", "."),
                        ) * item?.orderproductqty,
                      )}

                      {/* <CurrencyInput
                        disabled
                        value={
                          Number(
                            item.productcost
                              .replace(/\./g, "")
                              .replace(",", "."),
                          ) * item.orderproductqty
                        }
                        decimalSeparator=","
                        thousandSeparator="."
                        precision={2}
                        prefix="€ "
                        style={{ border: "none" }}
                      /> */}
                    </td>
                  </tr>
                </tbody>
              );
            })}
          </table>

          <div className="horizontalLine"></div>

          <table className="table table-borderless ms-4">
            <thead>
              <tr className="ps-">
                <th className="col-9"></th>
                <th className="col-2 purchTotal2 text-start py-4 px-4">
                  {t("TOTAL")}
                </th>
                <th className="col-2 purchTotal2 text-start py-4 ps-0">
                  {/* {formattedCurrency(totalExclusiveBtw)} */}
                  {europeanFormatWithSymbol(totalExclusiveBtw)}
                </th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ViewPurchasingOrder;
